import api from './api'

const reportService = {
  /**
   * Create a report for a scorable
   * @param {Object} data - Report data
   * @param {number} data.profile_id - Profile ID submitting the report
   * @param {number} data.scorable_id - Scorable ID being reported
   * @param {string} data.reason - Report reason (inappropriate, misinformation, spam, dangerous, copyright, other)
   * @param {string} [data.details] - Optional additional details
   */
  createReport: async (data) => {
    const response = await api.post('/reports', data)
    return response.data
  },

  /**
   * Get hidden scorables for current account
   */
  getMyHidden: async () => {
    const response = await api.get('/reports/my-hidden')
    return response.data
  },

  /**
   * Unhide a scorable for current account
   * @param {number} scorableId - Scorable ID to unhide
   */
  unhide: async (scorableId) => {
    const response = await api.delete(`/reports/unhide/${scorableId}`)
    return response.data
  },

  /**
   * Get reports submitted by current account
   */
  getMyReports: async () => {
    const response = await api.get('/reports/my-reports')
    return response.data
  },

  /**
   * Report reasons for UI
   */
  REPORT_REASONS: [
    { value: 'inappropriate', label: 'Inappropriate Content' },
    { value: 'misinformation', label: 'Misinformation' },
    { value: 'spam', label: 'Spam' },
    { value: 'dangerous', label: 'Dangerous Content' },
    { value: 'copyright', label: 'Copyright Violation' },
    { value: 'other', label: 'Other' },
  ]
}

export default reportService
